import { Link } from 'react-router-dom';
import { mangaCategories } from '@/mocks/manga';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
            漫画分类
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {mangaCategories.slice(1).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-500/30 hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors">
                <i className="ri-book-open-line text-xl text-primary-500 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-sm font-medium text-foreground-300 group-hover:text-foreground-100 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}